<template>
  <div class="land-page-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="400px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="editParam" :rules="rules" label-width="100px">
        <el-form-item label="域名:" prop="domain">
          <el-input type="text" v-model="editParam.domain" size="small"></el-input>
        </el-form-item>
        <el-form-item label="用途:" prop="uses">
          <el-select v-model.number="editParam.uses" size="small" placeholder="请选择用途">
            <el-option :value="0" label="落地页"></el-option>
            <el-option :value="1" label="商区"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="权重:" prop="weight">
          <el-input type="text" v-model.number="editParam.weight" size="small"></el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="remark">
          <el-input type="text" v-model="editParam.remark" size="small"></el-input>
        </el-form-item>
        <el-form-item label="开关:" prop="enable">
          <el-switch v-model="editParam.enable"></el-switch>
        </el-form-item>
        <!-- <el-form-item label="模版名称:" prop="template">
          <el-input type="text" v-model="editParam.template" size="small"></el-input>
        </el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="handleOK()" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import api from "@/api";
export default {
  data() {
    return {
      title: "添加落地页",
      dialogVisible: false,
      flag: false,
      id: "",
      type: "",
      editParam: {
        domain: "",
        uses: "",
        remark: "",
        weight: "",
        enable: false,
        // template: '',
      },
      rules: {
        domain: [{ required: true, message: "请输入域名", trigger: "blur" }],
        uses: [{ required: true, message: "请选择用途", trigger: "change" }],
        template: [
          { required: true, message: "请输入模版名", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    // 表单验证提交
    handleOK() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          if (this.type === "add") {
            this.addLandPage();
          } else {
            this.editLandPage();
          }
        } else {
          return false;
        }
      });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.editParam = {
        domain: "",
        uses: "",
        remark: "",
        weight: "",
        enable: false,
        // template: '',
      };
      this.$refs.form.resetFields();
    },
    // 新增落地页
    addLandPage() {
      api
        .addLandPage(this.editParam)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "新增成功",
              type: "success",
            });
          } else {
            this.$message.error("新增失败");
          }
          this.flag = false;
          this.handleClose();
          this.$emit("handlerLandPage");
        })
        .catch(() => {
          this.flag = false;
          this.handleClose();
        });
    },
    // 编辑落地页
    editLandPage() {
      api
        .editLandPage(Object.assign(this.editParam, { id: this.id }))
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "编辑成功",
              type: "success",
            });
          } else {
            this.$message.error("编辑失败");
          }
          this.flag = false;
          this.handleClose();
          this.$emit("handlerLandPage");
        })
        .catch(() => {
          this.flag = false;
          this.handleClose();
        });
    },
    // 打开弹窗组件
    open(type, data) {
      this.type = type;
      this.dialogVisible = true;
      if (type === "add") {
        this.title = "新增落地页";
      } else {
        this.title = "编辑落地页";
        this.id = data.id;
        this.editParam.domain = data.domain;
        this.editParam.uses = data.uses;
        this.editParam.remark = data.remark;
        this.editParam.weight = data.weight;
        this.editParam.enable = data.enable;
      }
    },
  },
};
</script>
